import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { SwitchInput, type SwitchInputProps } from '@interxfi/design-system/components/input/switch-input/switch-input';

interface PropsWithLens extends Omit<SwitchInputProps, 'name' | 'value' | 'prefix'> {
  lens: Lens<boolean>;
  shouldUnregister?: boolean;
}

export function AppSwitchInputWithLens({ onChange, shouldUnregister, lens, ...props }: PropsWithLens) {
  const { field, fieldState } = useController({ shouldUnregister, ...lens.interop() });
  const fieldOnChange = field.onChange;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      fieldOnChange?.(e.target.value);
      onChange?.(e);
    },
    [fieldOnChange, onChange],
  );

  return (
    <SwitchInput {...props} {...field} checked={props.checked ?? field.value ?? false} error={fieldState.error?.message} onChange={handleChange} />
  );
}
